import { LoadableElement } from '@99designs/frontend-components/components/LoadableElement';
import { getRoleFromUser } from '@99designs/apps/spa/pages/create/common/utils/getRole';
import CreateContext from '@99designs/apps/spa/pages/create/components/CreateContext';
import ErrorBoundary from '@99designs/apps/spa/pages/create/components/ErrorBoundary';
import { BriefRoutes } from './routes';
import * as React from 'react';
import { CreateComponent } from '@99designs/apps/spa/pages/create/CreateApp.generated';
import { Helmet } from 'react-helmet-async';

export default function CreateApp() {
    return (
        <ErrorBoundary>
            <Helmet bodyAttributes={{ class: 'no-body-x-overflow' }} />
            <CreateComponent>
                {({ loading, error, data }) => {
                    if (loading)
                        return <LoadableElement isLoading={true} variations={['relative ']} />;
                    if (error) throw error;
                    if (data) {
                        return (
                            <CreateContext.Provider
                                value={{
                                    site: data.site,
                                    role: getRoleFromUser(data.me.user),
                                }}
                            >
                                <ErrorBoundary>
                                    <BriefRoutes />
                                </ErrorBoundary>
                            </CreateContext.Provider>
                        );
                    }
                    return null;
                }}
            </CreateComponent>
        </ErrorBoundary>
    );
}
